export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7894.2f0d1b81.jpg";